import * as React from 'react'
import { useState, useEffect } from 'react'
import RelojChecador from '../../../Services/Catalogos/RelojChecador'
import DataTable from 'react-data-table-component'
import * as XLSX from 'xlsx'
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo'
import { Button, Card, Form, Col, Row } from 'react-bootstrap'
import { BsSearch, BsFileEarmarkExcel } from 'react-icons/bs'
import { DTOReporteFechas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteFechas'
import { DTOReporteChecadas } from '../../Catalogos/CatalogosReloj/DTO/DTOReporteChecadas'

export default function RptTotalHours() {
  const [inicio, setInicio] = useState<string>(currentDate())
  const [fin, setFin] = useState<string>(currentDate())
  const [filtro, setFiltro] = useState<string>('')

  const [data, setData] = useState<Array<DTOReporteFechas>>([])
  const [filteredData, setFilteredData] = useState<Array<DTOReporteFechas>>([])
  const [detalleData, setDetalleData] = useState<Array<DTOReporteChecadas>>([])

  const [showToast, setShowToast] = useState<boolean>(false)
  const [toastMsg, setToastMsg] = useState<string>('')
  const [toastHeader, setToastHeader] = useState<string>('')
  const [toastColor, setToastColor] = useState<string>('')

  useEffect(() => {
    generarReporte()
  }, [])

  function currentDate(): string {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const yyyy = today.getFullYear()
    return `${yyyy}-${mm}-${dd}`
  }

  const mostrarToast = (header: string, msg: string, color: string) => {
    setToastHeader(header)
    setToastMsg(msg)
    setToastColor(color)
    setShowToast(true)
  }

  const generarReporte = async () => {
    if (!inicio || !fin) {
      mostrarToast('Validación', 'Seleccione fecha de inicio y fecha fin.', 'warning')
      return
    }

    try {
      const [resumenResponse, detalleResponse] = await Promise.all([
        RelojChecador.getEntradasSalidasFechas(inicio, fin),
        RelojChecador.getReporteChecadas(inicio, fin),
      ])

      setData(resumenResponse.data)
      setFilteredData(resumenResponse.data)
      setDetalleData(detalleResponse.data)

      setFiltro('')
      mostrarToast('Informativo', 'Información encontrada correctamente.', 'success')
    } catch (error) {
      mostrarToast('Error', 'Ocurrió un error al generar el reporte.', 'danger')
    }
  }

  const columns = [
    {
      name: 'ID',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.userId,
      sortable: true,
    },
    {
      name: 'No. Empleado',
      width: '140px',
      selector: (row: DTOReporteFechas) => row.numeroEmpleado,
      sortable: true,
    },
    {
      name: 'Nombre',
      width: '220px',
      selector: (row: DTOReporteFechas) => row.nombreEmpleado,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Departamento',
      width: '220px',
      selector: (row: DTOReporteFechas) => row.departamento,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Oficina',
      width: '180px',
      selector: (row: DTOReporteFechas) => row.oficina,
      sortable: true,
    },
    {
      name: 'Hora Entrada',
      width: '160px',
      selector: (row: DTOReporteFechas) => row.horaEntrada,
      sortable: true,
    },
    {
      name: 'Total Horas',
      width: '140px',
      selector: (row: DTOReporteFechas) => row.totalHoras,
      sortable: true,
    },
    {
      name: 'Horas Extras',
      width: '140px',
      selector: (row: DTOReporteFechas) => row.horasExtras,
      sortable: true,
    },
    {
      name: 'Faltas',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.totalFaltas,
      sortable: true,
    },
    {
      name: 'Retardos',
      width: '120px',
      selector: (row: DTOReporteFechas) => row.totalRetardos,
      sortable: true,
    },
  ]

  const filtraReporte = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = e.target.value.toLowerCase()
    setFiltro(searchText)

    const filtered = data.filter((item) =>
      String(item.numeroEmpleado || '').toLowerCase().includes(searchText) ||
      String(item.nombreEmpleado || '').toLowerCase().includes(searchText)
    )

    setFilteredData(filtered)
  }

const horasAMinutos = (valor?: string | null): number => {
  if (!valor) return 0

  const partes = valor.split(':')
  const horas = Number(partes[0]) || 0
  const minutos = Number(partes[1]) || 0

  return horas * 60 + minutos
}

const minutosAHoras = (minutosTotales: number): string => {
  const horas = Math.floor(minutosTotales / 60)
  const minutos = minutosTotales % 60

  return `${horas}:${String(minutos).padStart(2, '0')}`
}

const exportExcel = () => {
  const wb = XLSX.utils.book_new()

  // =========================
  // HOJA 1: RESUMEN
  // =========================
  const resumenData = filteredData.map((item) => ({
    ID: item.userId,
    NumEmpleado: item.numeroEmpleado,
    Nombre: item.nombreEmpleado,
    Departamento: item.departamento,
    Oficina: item.oficina,
    HoraEntrada: item.horaEntrada,
    TotalHoras: item.totalHoras,
    HorasExtras: item.horasExtras,
    Faltas: item.totalFaltas,
    Retardos: item.totalRetardos,
  }))

  const wsResumen = XLSX.utils.json_to_sheet(resumenData)
  XLSX.utils.book_append_sheet(wb, wsResumen, 'Resumen')

  // =========================
  // HOJA 2: DETALLE BÁSICO ACOMODADO
  // =========================
  
  const detalleOrdenado = [...detalleData].sort((a, b) => {
  const empA = String(a.numeroEmpleado || '')
  const empB = String(b.numeroEmpleado || '')
  const fechaA = String(a.fecha || '')
  const fechaB = String(b.fecha || '')

  const ordenEmpleado = empA.localeCompare(empB, undefined, {
    numeric: true,
    sensitivity: 'base',
  })

  if (ordenEmpleado !== 0) return ordenEmpleado

  return fechaA.localeCompare(fechaB)
})




  const grupos = detalleOrdenado.reduce<Record<string, DTOReporteChecadas[]>>(
    (acc, item) => {
      const key = `${item.numeroEmpleado}__${item.nombreEmpleado}`

      if (!acc[key]) {
        acc[key] = []
      }

      acc[key].push(item)
      return acc
    },
    {}
  )

  const detalleRows: any[][] = []

  detalleRows.push([
    'ID',
    'NumEmpleado',
    'Nombre',
    'Fecha',
    'Entrada 1',
    'Salida 1',
    'Entrada 2',
    'Salida 2',
    'Entrada 3',
    'Salida 3',
    'Total Horas',
  ])

  Object.values(grupos).forEach((itemsEmpleado) => {
    const primerRegistro = itemsEmpleado[0]

    let totalEmpleadoMinutos = 0

    itemsEmpleado.forEach((item) => {
      totalEmpleadoMinutos += horasAMinutos(item.totalHoras)

      detalleRows.push([
        item.userId,
        item.numeroEmpleado,
        item.nombreEmpleado,
        item.fecha,
        item.entrada1 || '',
        item.salida1 || '',
        item.entrada2 || '',
        item.salida2 || '',
        item.entrada3 || '',
        item.salida3 || '',
        item.totalHoras,
      ])
    })

    detalleRows.push([
      '',
      primerRegistro.numeroEmpleado,
      primerRegistro.nombreEmpleado,
      '',
      '',
      '',
      '',
      '',
      '',
      'Total empleado',
      minutosAHoras(totalEmpleadoMinutos),
    ])

    detalleRows.push([])
  })

  const wsDetalle = XLSX.utils.aoa_to_sheet(detalleRows)
  XLSX.utils.book_append_sheet(wb, wsDetalle, 'Detalle')

  XLSX.writeFile(wb, `ReporteSemanal_${inicio}_${fin}.xlsx`)
}























  
  // const exportExcel = () => {
  //   const wb = XLSX.utils.book_new()

  //   const resumenData = filteredData.map((item) => ({
  //     ID: item.userId,
  //     NumEmpleado: item.numeroEmpleado,
  //     Nombre: item.nombreEmpleado,
  //     Departamento: item.departamento,
  //     Oficina: item.oficina,
  //     HoraEntrada: item.horaEntrada,
  //     TotalHoras: item.totalHoras,
  //     HorasExtras: item.horasExtras,
  //     Faltas: item.totalFaltas,
  //     Retardos: item.totalRetardos,
  //   }))

  //   const detalleExcelData = detalleData.map((item) => ({
  //     ID: item.userId,
  //     NumEmpleado: item.numeroEmpleado,
  //     Nombre: item.nombreEmpleado,
  //     Fecha: item.fecha,
  //     Entrada1: item.entrada1 || '',
  //     Salida1: item.salida1 || '',
  //     Entrada2: item.entrada2 || '',
  //     Salida2: item.salida2 || '',
  //     Entrada3: item.entrada3 || '',
  //     Salida3: item.salida3 || '',
  //     TotalHoras: item.totalHoras,
  //   }))

  //   const wsResumen = XLSX.utils.json_to_sheet(resumenData)
  //   const wsDetalle = XLSX.utils.json_to_sheet(detalleExcelData)

  //   XLSX.utils.book_append_sheet(wb, wsResumen, 'Resumen')
  //   XLSX.utils.book_append_sheet(wb, wsDetalle, 'Detalle')

  //   XLSX.writeFile(wb, `ReporteSemanal_${inicio}_${fin}.xlsx`)
  // }

  return (
    <div className="mt-2">
      <Card>
        <Card.Body>
          <Form>
            <Row className="align-items-center">
              <Col xs={2}>
                <Form.Label>Desde</Form.Label>
                <Form.Control
                  type="date"
                  value={inicio}
                  onChange={(e) => setInicio(e.target.value)}
                  size="sm"
                />
              </Col>

              <Col xs={2}>
                <Form.Label>Hasta</Form.Label>
                <Form.Control
                  type="date"
                  value={fin}
                  onChange={(e) => setFin(e.target.value)}
                  size="sm"
                />
              </Col>

              <Col xs={3}>
                <Form.Label>Buscar</Form.Label>
                <Form.Control
                  type="text"
                  value={filtro}
                  placeholder="Buscar por No. Empleado o Nombre..."
                  onChange={filtraReporte}
                  size="sm"
                />
              </Col>

              <Col xs={2}>
                <Form.Label>&nbsp;</Form.Label>
                <Button
                  variant="success"
                  onClick={exportExcel}
                  size="sm"
                  className="w-100"
                >
                  <BsFileEarmarkExcel /> Excel
                </Button>
              </Col>

              <Col xs={2}>
                <Form.Label>&nbsp;</Form.Label>
                <Button
                  variant="primary"
                  onClick={generarReporte}
                  size="sm"
                  className="w-100"
                >
                  <BsSearch /> Buscar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      <MsgInformativo
        show={showToast}
        msg={toastMsg}
        header={toastHeader}
        msgColor={toastColor}
        closeToast={() => setShowToast(false)}
      />

      <Card className="mt-3 shadow-sm">
        <Card.Header className="bg-light fw-bold">
          Reporte semanal sin archivo
        </Card.Header>

        <Card.Body>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            paginationPerPage={10}
            striped
            highlightOnHover
            dense
            noHeader
            pointerOnHover
          />
        </Card.Body>
      </Card>
    </div>
  )
}